export const AUTO_LOGOUT_MINUTE_OPTIONS = [3, 5, 10, 15, 30, 60, 90, 120] as const;

export type AutoLogoutMinutes = (typeof AUTO_LOGOUT_MINUTE_OPTIONS)[number];

export const DEFAULT_AUTO_LOGOUT_MINUTES: AutoLogoutMinutes = 10;

export function isSupportedAutoLogoutMinutes(value: number): value is AutoLogoutMinutes {
  return (AUTO_LOGOUT_MINUTE_OPTIONS as readonly number[]).includes(value);
}

export function resolveAutoLogoutMinutes(value: number | null | undefined): AutoLogoutMinutes {
  return typeof value === "number" && isSupportedAutoLogoutMinutes(value)
    ? value
    : DEFAULT_AUTO_LOGOUT_MINUTES;
}

export function hasIdleTimeoutElapsed(lastActivityAt: number, now: number, timeoutMs: number) {
  return now - lastActivityAt >= timeoutMs;
}
